"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const globals_1 = require("../../infra/globals");
const date_utils_1 = require("../../infra/date_utils");
const utils_1 = require("../../infra/utils");
const game_records_table_1 = __importDefault(require("../components/game_records_table"));
const players_table_1 = __importDefault(require("../components/players_table"));
class GameEventView extends HTMLElement {
    gameEventRef;
    static tag = "game-event-view";
    constructor(gameEventRef) {
        super();
        this.gameEventRef = gameEventRef;
    }
    getGameEvent = async () => {
        const eventDoc = await (0, firestore_1.getDoc)((0, firestore_1.doc)(globals_1.db, "game_events", this.gameEventRef));
        this.gameEvent = (0, utils_1.addFirebaseRef)(eventDoc.data(), eventDoc.id);
    };
    async connectedCallback() {
        document.title = "Evento";
        this.prepareGameEventPage();
        await this.getGameEvent();
        if (this.gameEvent) {
            document.title = `Evento | ${this.gameEvent.name}`;
            this.setGameEventPage();
        }
    }
    prepareGameEventPage = () => {
        this.innerHTML = `
      <div id="event-name"></div>

      <div id="card"></div>
    `;
    };
    setGameEventPage = () => {
        this.setGameEventName();
        this.setGameEventCard();
        this.append(new players_table_1.default("Participantes do Evento", false, this.gameEventRef), new game_records_table_1.default("Partidas do Evento", "", "", this.gameEventRef));
    };
    setGameEventName = () => {
        const gameEventNameDiv = this.querySelector("#event-name");
        gameEventNameDiv.innerHTML = `
      <h2>${this.gameEvent.name}</h2>
    `;
    };
    setGameEventCard = () => {
        const gameEventCardDiv = this.querySelector("#card");
        const dateLength = this.gameEvent.dates.length;
        const formattedDateInit = date_utils_1.DateUtils.formatDate(new Date(this.gameEvent.dates[0]));
        const formattedDateEnd = date_utils_1.DateUtils.formatDate(new Date(this.gameEvent.dates[dateLength - 1]));
        gameEventCardDiv.innerHTML = `
      <div id="legend">
        <span>Tipo</span>
        <span>Data de Início</span>
        <span>Data de Fim</span>
        <span>Total de Partidas</span>
        <span>Total de Partici-pantes</span>
      </div>

      <div id="content">
        <span>${this.gameEvent.type}</span>
        <span>${formattedDateInit}</span>
        <span>${formattedDateEnd}</span>
        <span>${this.gameEvent.gamesTotal}</span>
        <span>${this.gameEvent.participants.length}</span>
      </div>
    `;
    };
}
exports.default = GameEventView;
//# sourceMappingURL=data:application/json;base64,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